import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import FormPhoneInputComponent from './js/form-phone-input.component';

ComponentsFactory.getInstance().define('form-phone-input', FormPhoneInputComponent);
